import {
  Box,
  Skeleton,
  Typography,
  useTheme
} from "@mui/material";
import {
  BarNavigation,
  ButtonBar,
  CentroControle,
  EmpreendimentoConfig,
} from "../../components";
import { FuncionarioConfig } from "../../components/barragem/configs/funcionario";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack, ErrorOutline } from "@mui/icons-material";
import { useBarragemContext } from "../../context";
import { Fluxogramas } from "../Flow";

export const BarragemConfig: React.FC = () => {
  const { palette } = useTheme();

  const navigate = useNavigate();
  const barragemData = useBarragemContext().barragem;
  const [pageContent, setPageContent] = useState<JSX.Element>(<EmpreendimentoConfig />);

  const [buttons, setButtons] = useState<ButtonBar<JSX.Element>[]>([
    {
      text: "EMPREENDIMENTO",
      select: true,
      args: <EmpreendimentoConfig />,
    },
    {
      text: "FUNCIONÁRIOS",
      select: false,
      args: <FuncionarioConfig />,
    },
    {
      text: "CENTRO DE CONTROLE",
      select: false,
      args: <CentroControle />,
    },
    {
      text: "FLUXOGRAMAS",
      select: false,
      args: <Fluxogramas />,
    },
  ]);

  useEffect(() => {
    buttons[0].text = (!barragemData || "error" in barragemData) ? "EMPREENDIMENTO" : barragemData.nome.toUpperCase();
    setButtons([...buttons]);
  }, [barragemData]);

  if (barragemData && 'error' in barragemData) {
    return (
      <Box
        sx={{
          padding: "5em",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <ErrorOutline color="error" />
        <div style={{ width: "15px" }} />
        <Box>
          <Typography
            fontWeight={"bold"}
            color={palette.getContrastText(palette.background.paper)}
          >
            {barragemData.error}
          </Typography>
          <Typography
            color={palette.getContrastText(palette.background.paper)}
          >
            {barragemData.message}
          </Typography>
        </Box>
      </Box>
    );
  }

  return <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
    <BarNavigation<JSX.Element>
      onHome={() => navigate(`/app/${barragemData?.id}`)}
      homeIcon={ArrowBack}
      buttons={buttons}
      onClick={(index, args) => {
        let indexTrue = -1;
        const newButtons = buttons.map((button, i) => {
          if (button.select) indexTrue = i;
          return {
            ...button,
            select: i === index,
          };
        });

        if (indexTrue !== index) {
          setButtons(newButtons);
          setPageContent(args);
        }
      }}
    />

    <Box sx={{
      width: "100%",
      height: "100%",
      overflowY: "auto",
    }} >
      {!barragemData && <Skeleton />}
      {barragemData && pageContent}
    </Box>
  </Box>;
};
